/*
  Responsive styling prop that can be used dynamically
  Example:
   {
     base: 'vertical',
     '2xs': 'horizontal',
   }
 */
export interface ResponsiveStyleProp<TOption> {
    base: TOption
    '2xs'?: TOption
    md?: TOption
    lg?: TOption
}

export interface ResponsivePropClassNameMap<
    TOption extends string = string,
    TOptionMap = Record<TOption, string>
> {
    base: TOptionMap
    '2xs'?: TOptionMap
    md?: TOptionMap
    lg?: TOptionMap
}

// We can uncomment this if we need to support dynamic styles at more breakpoints.
// The main ResponsiveValue type above is deliberately limited so we don't have to
// compile so many possibly unused tailwind classes
//
// export interface ResponsiveValueMoreBreakpoints<TValue> extends ResponsiveValue<TValue> {
//     xs: TValue,
//     sm: TValue,
//     xl: TValue
// }

export class ResponsiveClassNames<TValue extends string = string> {
    #classNameMap: ResponsivePropClassNameMap<TValue>

    constructor(constants: ResponsivePropClassNameMap<TValue>) {
        this.#classNameMap = constants
    }

    buildClassString(propVal: ResponsiveStyleProp<TValue>): string {
        return Object.entries(propVal)
            .map(
                ([breakpoint, val]) =>
                    this.#classNameMap[
                        breakpoint as keyof ResponsivePropClassNameMap
                    ]?.[val as TValue]
            )
            .filter(Boolean)
            .join(' ')
    }
}
